import functions from "./functions";
import mixins from "./mixins";
import { fonts, palette, sizes } from "./variables";

export default { functions, mixins, fonts, palette, sizes };
